import Vue from "vue";

import InitializationError from "@/views/errors/InitializationError.vue";
import ErrorItem from "@/views/components/formFields/ErrorItem.vue";
import ActionButton from "@/views/components/utilityComponents/ActionButton.vue";

Vue.component("InitializationError", InitializationError);
Vue.component("ErrorItem", ErrorItem);
Vue.component("ActionButton", ActionButton);
